import script from "./FourthRound.vue?vue&type=script&setup=true&lang=js"
export * from "./FourthRound.vue?vue&type=script&setup=true&lang=js"

import "./FourthRound.vue?vue&type=style&index=0&id=4b301c69&lang=css"

const __exports__ = script;

export default __exports__